import * as angular from 'angular';
import { DirectiveDefinition } from '../directiveDefinition';
import { guidEmpty } from '../../common/constants';

interface DefaultCPVScope extends angular.IScope {
    vm: any;
}

class DefaultConnectionPointValidatorController implements angular.IController {
    static $inject = ['$scope', '$element'];

    constructor(
        private _$scope: DefaultCPVScope,
        private _$element: angular.IAugmentedJQuery
    ) {
    }

    $onInit() {
        const scope = this._$scope;
        const controller = this._$element.controller('ngModel');
        controller.$validators.required = (modelValue, viewValue) => {
            let isValid = true;
            if (scope.vm.connectionPoints && scope.vm.connectionPoints.length > 0
                && (controller.$isEmpty(modelValue) || controller.$isEmpty(viewValue) || viewValue === guidEmpty)) {
                isValid = false;
            }
            return isValid;
        };
    }
}

export const DefaultConnectionPointValidatorDirective: DirectiveDefinition = {
    directiveId: 'wtDefaultConnectionPointValidator',
    restrict: 'A',
    controller: DefaultConnectionPointValidatorController,
    //controllerAs: 'vm',
    require: ['ngModel']
};